/** Incomplete setup should always re-enter through Setup shell routing. */
export function sanitizeSetupRedirectPath(path: string | null | undefined): string | null {
  if (!path) {
    return null
  }

  const [pathname] = path.split('?')
  if (pathname === '/setup' || pathname.startsWith('/setup/')) {
    return '/setup'
  }

  return path
}
